import { render, staticRenderFns } from "./AccountLink.vue?vue&type=template&id=2e732576&scoped=true&"
import script from "./AccountLink.vue?vue&type=script&lang=ts&"
export * from "./AccountLink.vue?vue&type=script&lang=ts&"
import style0 from "./AccountLink.vue?vue&type=style&index=0&id=2e732576&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e732576",
  null
  
)

export default component.exports